<template>
  <div>
    <Drawer
      include-header
      :no-footer="!appointment?.links?.cancel"
      @hide-drawer="handleDrawerClosed"
      @show-drawer="handleDrawerOpened"
    >
      <template #drawerHeader>
        <a
          v-if="appointment?.job"
          class="w-full h-[48px] pt-[10px] drawer-header px-4 cursor-pointer text-white bg-primary-600 text-[13px] no-underline block"
          :href="jobShowPath(appointment.job.id)"
        >
          <div class="relative flex items-center justify-between w-full">
            <div class="underline">
              Job #{{ appointment.job.id }}
              {{
                appointment.job.status ? `(${appointment.job.status.name})` : ""
              }}
            </div>
            <div class="flex items-center gap-1">
              View Job <ArrowRight class="w-4" />
            </div>
          </div>
        </a>
      </template>
      <template #title>
        <div id="status-dropdown-target"></div>
      </template>
      <AppointmentDetailsContent
        :appointment-id="appointmentId"
        @appointment-change="updateAppointment"
      />
      <template #footer>
        <Button
          label="Cancel Appointment"
          type="Alert"
          outline
          class="w-full"
          @click="toggleCancelDrawer"
        />
      </template>
    </Drawer>
    <CancelAppointmentDrawer
      v-if="cancelDrawer"
      :appointment="appointment"
      @hide-drawer="toggleCancelDrawer"
      @refresh-appointment="handleAppointmentCanceled"
    />
  </div>
</template>

<script setup lang="ts">
import { nextTick, onBeforeUnmount, ref } from "vue";
import { updateQueryParam } from "@/lib/url";

import Button from "@/components/Seranova/Buttons/Button.vue";
import Drawer from "@/components/Seranova/Drawer/Drawer.vue";
import ArrowRight from "@/images/ArrowRight.svg?component";
import { jobShowPath } from "@/mixins/path_helpers";
import { useEventCalendar } from "@/SchedulerV2/useEventCalendar";
import { AppointmentV2 } from "@/typings/appointment";
import AppointmentDetailsContent from "./AppointmentDetailsContent.vue";
import CancelAppointmentDrawer from "./CancelAppointmentDrawer.vue";
const emit = defineEmits(["hide-drawer", "show-drawer", "appointment-updated"]);
const props = defineProps<{ appointmentId: string | number }>();
const { refreshTimeline } = useEventCalendar();
const appointment = ref<AppointmentV2 | null>(null);
const cancelDrawer = ref(false);

const updateAppointment = (data: AppointmentV2) => {
  // Only update events if the appointment already exists
  if (appointment.value) {
    refreshTimelineEvents();
  }
  appointment.value = data;
  emit("appointment-updated", appointment.value);
};
const refreshTimelineEvents = () => {
  refreshTimeline();
};
const toggleCancelDrawer = () => {
  cancelDrawer.value = !cancelDrawer.value;
};
const removeBackdrop = () => {
  nextTick(() => {
    $("div[drawer-backdrop]").remove();
  });
};
const handleAppointmentCanceled = () => {
  refreshTimelineEvents();
  toggleCancelDrawer();
  emit("hide-drawer");
};

const handleDrawerOpened = () => {
  updateQueryParam("appointment_id", props.appointmentId.toString());
  emit("show-drawer");
};
const handleDrawerClosed = () => {
  emit("hide-drawer");
  updateQueryParam("appointment_id", null);
};

onBeforeUnmount(() => {
  removeBackdrop();
});
</script>

<style lang="scss"></style>
